import React from 'react';

import I18n from 'utils/I18n';
import InfoModal from '../InfoModal/InfoModal';

import styles from './styles.scss';

const HideStatsInfo = () => {
  const hideStatsContent = (
    <>
      <div className={styles.modalHeader}>
        {I18n.t('templates.activities.edit.hide_stats.modal.title')}
      </div>
      <p>{I18n.t('templates.activities.edit.hide_stats.modal.text_1')}</p>
      <p>{I18n.t('templates.activities.edit.hide_stats.modal.text_2')}</p>
    </>
  );

  return <InfoModal>{hideStatsContent}</InfoModal>;
};

export default HideStatsInfo;
